import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useHistory } from 'react-router-dom';
import HrbTranslate from '../../language/HrbTranslate';
import { ArrowBackIos } from '@mui/icons-material';
import { RouteConstants } from '../../../router/services/RouteConstants';
import "./BackLink.scss";

const BackLink = (props) => {
    const history = useHistory();
    const isHome = history?.location?.pathname === RouteConstants.HOME

    const goBack = () => {
        history.goBack();
    }

    return (
        !isHome && <a onClick={goBack}>
            <div className={classnames('backlink', { 'alignright': Boolean(props.isRight) })}>
                <ArrowBackIos />
                <HrbTranslate text='App.Back' />
            </div>
        </a>
    )
}

BackLink.propTypes = {
    isRight: PropTypes.bool
}

export default BackLink;